module.exports = __webpack_public_path__ + "img/item_img1.ea568e46.png";